import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import NavBar from '../components/NavBar';
import { useAuth } from '../lib/auth';
import { authAPI, formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { MailCheck, RefreshCw } from 'lucide-react';

export default function VerifyPending() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (user?.email_verified || user?.role === 'admin') {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    const interval = setInterval(async () => {
      await refreshUser();
    }, 5000);
    return () => clearInterval(interval);
  }, [refreshUser]);

  const resend = async () => {
    setSending(true);
    try {
      await authAPI.resendVerification();
      toast.success('Onay e-postasi tekrar gonderildi! Mail kutunuzu kontrol edin.');
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <NavBar />
      <div className="max-w-lg mx-auto px-4 py-20">
        <div className="aurora-card rounded-3xl p-10 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-fuchsia-500/15 border border-fuchsia-500/30 flex items-center justify-center">
            <MailCheck className="w-10 h-10 text-fuchsia-400" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Mail Kutunuzu Kontrol Edin</h1>
          <p className="text-muted-foreground mb-2">
            <strong className="text-foreground">{user?.email}</strong> adresine bir onay e-postasi gonderdik.
          </p>
          <p className="text-sm text-muted-foreground mb-8">
            E-postadaki butona tiklayarak hesabinizi aktif edin. Onay sonrasi bu sayfa otomatik olarak yonlendirilecek.
          </p>

          <div className="flex flex-col gap-3 items-center">
            <Button onClick={resend} disabled={sending} variant="outline" className="border-fuchsia-500/40 text-fuchsia-300">
              {sending ? <><RefreshCw className="w-4 h-4 mr-2 animate-spin" /> Gonderiliyor...</> : 'Tekrar Gonder'}
            </Button>
            <p className="text-xs text-muted-foreground">Spam klasorunu de kontrol etmeyi unutmayin.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
